module.exports = __webpack_public_path__ + "img/tour.deba5b3d.png";